import React from "react";
import HamburgerMenu from "../src/assests/hamburger.svg"; // Verify the path is correct
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui'; // Import UI component for wallet connection


// Ensure you have the styles for the wallet adapter UI components imported in your app,
// typically in your root component or main stylesheet:
// import '@solana/wallet-adapter-react-ui/styles.css';

const Header = ({ toggleNavbarVisibility }) => {
  return (
    <header className="text-white flex justify-between items-center p-2">
      <button className="block sm:hidden" onClick={toggleNavbarVisibility}>
        <img src={HamburgerMenu} alt="Hamburger Menu Icon" />
      </button>
      <div>
        {/* WalletMultiButton automatically handles wallet connection/disconnection */}
        <WalletMultiButton />
      </div>
    </header>
  );
};

export default Header;
